import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle 
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import axios from 'axios';

function CrudPaises() {
  const [paises, setPaises] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPais, setCurrentPais] = useState(null);
  const [det_pais, setDetPais] = useState('');
  const [cod_pais, setCodPais] = useState('');
  const [simbolo_moneda, setSimboloMoneda] = useState('');

  useEffect(() => {
    fetchPaises();
  }, []);

  const fetchPaises = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/paises`);
      setPaises(response.data);
    } catch (error) {
      console.error('Error al obtener los países:', error);
    }
  };

  const handleCreate = () => {
    setCurrentPais(null);
    setDetPais('');
    setCodPais('');
    setSimboloMoneda('');
    setOpen(true);
  };

  const handleEdit = (pais) => {
    setCurrentPais(pais);
    setDetPais(pais.det_pais);
    setCodPais(pais.cod_pais);
    setSimboloMoneda(pais.simbolo_moneda);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este país?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/paises/${id}`);
        fetchPaises();
      } catch (error) {
        console.error('Error al eliminar el país:', error);
      }
    }
  };

  const handleSubmit = async () => {
    try {
      if (currentPais) {
        // Editar país
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/paises/${currentPais.id_pais}`, { det_pais, cod_pais, simbolo_moneda });
      } else {
        // Crear país
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/paises`, { det_pais, cod_pais, simbolo_moneda });
      }
      fetchPaises();
      setOpen(false);
    } catch (error) {
      console.error('Error al guardar el país:', error);
    }
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Gestión de Paises
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        startIcon={<AddIcon />} 
        onClick={handleCreate}
        style={{ marginBottom: '20px' }}
      >
        Crear País
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Símbolo de Moneda</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paises.map((pais) => (
              <TableRow key={pais.id_pais}>
                <TableCell>{pais.det_pais}</TableCell>
                <TableCell>{pais.cod_pais}</TableCell>
                <TableCell>{pais.simbolo_moneda}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(pais)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="secondary" onClick={() => handleDelete(pais.id_pais)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{currentPais ? 'Editar País' : 'Crear País'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nombre del País"
            fullWidth
            value={det_pais}
            onChange={(e) => setDetPais(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Código del País"
            fullWidth
            value={cod_pais}
            onChange={(e) => setCodPais(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Símbolo de Moneda"
            fullWidth
            value={simbolo_moneda}
            onChange={(e) => setSimboloMoneda(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default CrudPaises;
